import { ToastContainer, toast as toastify } from 'react-toastify'
import type { ReactNode } from 'react'
import 'react-toastify/dist/ReactToastify.css'

const DEFAULT_TOAST_DURATION = 6000

export type ToastType = 'success' | 'error' | 'warning' | 'info'

type ToastOptions = {
  description?: string
  action?: {
    label: string
    onClick: () => void
  }
  duration?: number
  icon?: ReactNode
}

function showToast(type: ToastType, message: string, options?: ToastOptions) {
  const toastOptions: any = {
    autoClose: options?.duration ?? DEFAULT_TOAST_DURATION,
    icon: options?.icon,
  }
  const content = options?.description ? (
    <>
      <p>{message}</p>
      <p className="text-sm">{options.description}</p>
    </>
  ) : (
    message
  )

  switch (type) {
    case 'success':
      return toastify.success(content, toastOptions)
    case 'error':
      return toastify.error(content, toastOptions)
    case 'warning':
      return toastify.warning(content, toastOptions)
    case 'info':
      return toastify.info(content, toastOptions)
    default:
      return toastify(content, toastOptions)
  }
}

export const toast = {
  success: (msg: string, opts?: ToastOptions) =>
    showToast('success', msg, opts),
  error: (msg: string, opts?: ToastOptions) => showToast('error', msg, opts),
  warning: (msg: string, opts?: ToastOptions) =>
    showToast('warning', msg, opts),
  info: (msg: string, opts?: ToastOptions) => showToast('info', msg, opts),
}

export function ToastProvider() {
  return (
    <ToastContainer
      position="bottom-right"
      autoClose={DEFAULT_TOAST_DURATION}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
    />
  )
}
